module.exports = __webpack_public_path__ + "img/apple-icon-precomposed.ce818df.png";